<template>
  <div v-if="name" class="stamp-wrapper">
    <template v-if="name.length > 15">
      <EXTooltip :title="name" :delay="100">
        <v-list-item
          class="with-stamp-eval"
        >
          <div
            class="stamp-avatar eval-stamp-avatar"
            :class="{ 'eval-without-avatar': !avatar }"
          >
            <img
              v-if="avatar"
              class="picture"
              :src="avatar"
            />
            <div
              v-else
              class="picture initials-avatar"
            >
              {{ initials }}
            </div>
          </div>
          <v-list-item-content class="eval-stemp-content">
            <v-list-item-title>
              {{ name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </EXTooltip>
    </template>
    <template v-else>
      <v-list-item
        class="with-stamp-eval"
      >
        <div
          class="stamp-avatar eval-stamp-avatar"
          :class="{ 'eval-without-avatar': !avatar }"
        >
          <img
            v-if="avatar"
            class="picture"
            :src="avatar"
          />
          <div
            v-else
            class="picture initials-avatar"
          >
            {{ initials }}
          </div>
        </div>
        <v-list-item-content class="eval-stemp-content">
          <v-list-item-title>
            {{ name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <p v-if="date" class="stamp-date-text mb-0">{{ formattedDate }}</p>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import EXTooltip from '@components/tooltip/EXTooltip.vue';
const propsDef = defineProps({
  name: {
    type: String,
    default: '',
  },
  avatar: {
    type: String,
    default: '',
  },
  date: {
    type: [String, Number, Date],
    default: null,
  },
  show_time: {
    type: Boolean,
    default: true,
  },
});

const { name, avatar, date, show_time } = toRefs(propsDef);

const formattedDate = computed(() => {
  if (!date.value) return '';
  
  // Convert timestamp / string / Date into a Date object
  let dateObj;
  if (typeof date.value === 'number') {
    dateObj = new Date(date.value);
  } else if (typeof date.value === 'string') {
    dateObj = new Date(date.value);
  } else if (date.value instanceof Date) {
    dateObj = date.value;
  } else {
    return '';
  }

  if (isNaN(dateObj.getTime())) return ''; // invalid date

  // Format date
  const year = dateObj.getFullYear();
  const month = dateObj.toLocaleString('default', { month: 'short' });
  const day = String(dateObj.getDate()).padStart(2, '0');

  let datePart = `${day}-${month}-${year}`; // e.g., "06-Oct-2025"
  
  if (show_time.value) {
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const timePart = `${hours}:${minutes}`;
    return `${datePart} ${timePart}`; // e.g., "06-Oct-2025 18:20"
  }

  return datePart; // e.g., "06-Oct-2025"
});

const initials = computed(() => {
  if (name.value == null || name.value === '') return '';
  const s = String(name.value).trim();
  if (!s) return '';

  return s
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
});
</script>

<style scoped>
.stamp-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
}
.with-stamp-eval {
  border: 1px solid #eaecf0;
  border-radius: 50px;
  background-color: #f9fafb;
  height: 28px !important;
  display: inline-flex;
  max-width: 256px;
  padding: 6px;
  min-height: 22px;
  width: 115px;
  flex: none;
}
.with-stamp-eval .picture {
  width: 22px;
  height: 22px;
  border: 1px solid #dce0e7;
  border-radius: 50%;
}
.with-stamp-eval .initials-avatar {
  color: #667085;
  font-size: 10px;
  font-weight: 500;
  height: 22px;
  width: 22px;
  background-color: #f2f4f7;
  border-radius: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce0e7;
}
.with-stamp-eval .v-list-item__title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  color: #344054;
}
.with-stamp-eval .stamp-avatar {
  margin-right: 0px !important;
  position: relative;
  left: -3px;
  top: 2px;
}
.with-stamp-eval .eval-without-avatar {
  top: 0px;
}
.stamp-date-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #344054;
  margin-top: 2px;
  text-align: center;
}
</style>
